import "./TimeEdit.scss";
import TextField from "../TextField/TextField";
import NP, {EventKeyArgs} from "../../NP";
import Control from "../../Control";
import Delegate from "../../Delegate";


export enum TimeEditMode {
	Full = 0,
	HoursMinutes = 1,
	MinutesSeconds = 2,
}

export interface ITimeEditValue {
	Hours: number;
	Minutes: number;
	Seconds: number;
}

interface ITimeEditInserted {
	h: string | null;
	m: string | null;
	s: string | null;
}

export default class TimeEdit extends TextField {

	private _Mode: TimeEditMode;
	private _TimeValue: ITimeEditValue;

	//private _inserted: ITimeEditInserted = {h: null, m: null, s: null}; //введённые значения для каждой части
	private _spinEdit: HTMLElement;
	private _spinUp: HTMLButtonElement;
	private _spinDown: HTMLElement;
	private EvSpinChanged: Delegate;

	constructor(settings: object)
	{
		super(settings);
		this.setTimeValue(this._Value, false);
	}

	_initFields(settings: object)
	{
		this.EvSpinChanged = new Delegate();
		this._Mode = TimeEditMode.Full;
		super._initFields(settings);
	}

	_render()
	{
		super._render();
		this._input.setAttribute('autocomplete', 'off');

		this.addEvent(this._input, 'cut', this._onInputCut);
		this.addEvent(this._input, 'paste', this._onInputPaste);
		this.addEvent(this._input, 'drop', this._onInputPaste);
		this.addEvent(this._input, 'dragend', this._onInputPaste);

		this._renderNumericLayout();
	}

	_renderNumericLayout()
	{

		this._spinEdit = document.createElement("div");
		this._spinEdit.className = "text-field__spin-edit";

		this._spinUp = document.createElement("button");
		this._spinUp.className = `text-field__spin-edit__btn app-list-item__graphic ${NP.FontImages.spin_up}`;
		this._spinUp.addEventListener('click', () => this.incrementValue(true));
		this._spinUp.addEventListener('mousedown', () => this._spinUp.style.opacity = "0.5");
		this._spinUp.addEventListener('mouseup', () => this._spinUp.style.opacity = "1");

		this._spinDown = document.createElement("button");
		this._spinDown.className = `text-field__spin-edit__btn app-list-item__graphic ${NP.FontImages.spin_down}`;
		this._spinDown.addEventListener('click', () => this.incrementValue(false));
		this._spinDown.addEventListener('mousedown', () => this._spinDown.style.opacity = "0.5");
		this._spinDown.addEventListener('mouseup', () => this._spinDown.style.opacity = "1");

		this._spinEdit.appendChild(this._spinUp);
		this._spinEdit.appendChild(this._spinDown);
		this._inputContainer.appendChild(this._spinEdit);

		NP.addCssClass(this._input, 'text-field__input--spin-edit');

	}

	incrementValue(isPlus: boolean, fireEvent: boolean = true)
	{
		if (isPlus)
		{
			this._TimeValue.Seconds += 1;
			if (this._TimeValue.Seconds == 60)
			{
				this._TimeValue.Seconds = 0;
				this._TimeValue.Minutes += 1;

				if (this._TimeValue.Minutes == 60)
				{
					this._TimeValue.Minutes = 0;
					this._TimeValue.Hours += 1;
				}
			}
		}
		else
		{
			this._TimeValue.Seconds -= 1;
			if (this._TimeValue.Seconds == -1)
			{
				this._TimeValue.Seconds = 59;
				this._TimeValue.Minutes -= 1;

				if (this._TimeValue.Minutes == -1)
				{
					this._TimeValue.Minutes = 59;
					this._TimeValue.Hours -= 1;
				}
			}
		}

		this.setTimeValue(this._TimeValue, false)

		if (fireEvent !== false)
		{
			this.EvSpinChanged.fire(this, {IsPlus: isPlus})
			this.EvChanged.fire(this, {Value: this._TimeValue});
		}
	}

	getTimeValue(): ITimeEditValue
	{
		return this._TimeValue;
	}

	setTimeValue(value: string | ITimeEditValue, fireEvent: boolean = true)
	{
		let oldTime = this._TimeValue ? {...this._TimeValue} : this._TimeValue;
		if (value == undefined)
			this._TimeValue = this._getEmptyValue();
		if (typeof value === 'string')
			this._TimeValue = this._parseTime(value);
		else
		{
			this._TimeValue = this._getCorrectTime(value);
		}
		super.setValue(this._getTimeAsString(this._TimeValue));

		if (fireEvent !== false)
		{
			if (oldTime.Hours !== this._TimeValue.Hours ||
				 oldTime.Minutes !== this._TimeValue.Minutes ||
				 oldTime.Seconds !== this._TimeValue.Seconds ||
				 this._TimeValue == null && oldTime != null ||
				 this._TimeValue != null && oldTime == null)
			{
				this.EvChanged.fire(this, {Value: this._TimeValue});
			}
		}
	}

	_getEmptyValue(): ITimeEditValue
	{
		return {
			Hours: 0,
			Minutes: 0,
			Seconds: 0,
		};
	}

	_parseTime(str: string): ITimeEditValue
	{
		str = (str || '').trim();
		let ts = NP.getCurrentCulture().TimeSeparator;
		let regEx1Str = `^[0-9][0-9]${ts}[0-9][0-9]${ts}[0-9][0-9]$`;
		let regEx2Str = `^[0-9][0-9]${ts}[0-9][0-9]$`;
		let isFullFormat = new RegExp(regEx1Str).test(str);
		let isShortFormat = new RegExp(regEx2Str).test(str);
		if (isFullFormat || isShortFormat)
		{
			let arr = str.split(ts).map(x =>
			{
				let v = parseInt(x, 10);
				return isNaN(v) ? 0 : v;
			});
			switch (this._Mode)
			{
				case TimeEditMode.Full:
					return this._getCorrectTime({
						Hours: arr[0],
						Minutes: arr[1],
						Seconds: arr[2] || 0,
					});
				case TimeEditMode.HoursMinutes:
					return this._getCorrectTime({
						Hours: arr[0],
						Minutes: arr[1],
						Seconds: 0,
					});
				case TimeEditMode.MinutesSeconds:
					return this._getCorrectTime({
						Hours: 0,
						Minutes: isFullFormat ? arr[1] : arr[0],
						Seconds: isFullFormat ? arr[2] : arr[1],
					});
			}
		}
		return this._getEmptyValue();
	}

	_getTimeAsString(time: ITimeEditValue): string
	{
		let res = '';
		let ts = NP.getCurrentCulture().TimeSeparator;
		if (!time)
			time = this._getEmptyValue();
		let arr: number[];
		switch (this._Mode)
		{
			case TimeEditMode.Full:
				arr = [time.Hours, time.Minutes, time.Seconds];
				break;
			case TimeEditMode.HoursMinutes:
				arr = [time.Hours, time.Minutes];
				break;
			case TimeEditMode.MinutesSeconds:
				arr = [time.Minutes, time.Seconds];
				break;
		}
		arr.forEach((x, i) =>
		{
			if (i !== 0)
				res += ts;
			res += this._getTimePartAsString(x);
		});
		return res;
	}

	_isValid(str: string): boolean
	{
		let ts = NP.getCurrentCulture().TimeSeparator;
		let regEx1Str = `^[0-9][0-9]${ts}[0-9][0-9]${ts}[0-9][0-9]$`;
		let regEx2Str = `^[0-9][0-9]${ts}[0-9][0-9]$`;
		let isFullFormat = new RegExp(regEx1Str).test(str);
		let isShortFormat = new RegExp(regEx2Str).test(str);
		if (isFullFormat || isShortFormat)
		{
			let arr = str.split(ts).map(x => parseInt(x, 10));
			let time: ITimeEditValue;
			switch (this._Mode)
			{
				case TimeEditMode.Full:
					time = {
						Hours: arr[0],
						Minutes: arr[1],
						Seconds: arr[2] || 0,
					};
				case TimeEditMode.HoursMinutes:
					time = {
						Hours: arr[0],
						Minutes: arr[1],
						Seconds: 0,
					};
				case TimeEditMode.MinutesSeconds:
					time = {
						Hours: 0,
						Minutes: isFullFormat ? arr[1] : arr[0],
						Seconds: isFullFormat ? arr[2] : arr[1],
					};
			}
			if (this._isTimeValid(time))
				return true;
		}
		return false;
	}

	_isTimeValid(time: ITimeEditValue): boolean
	{
		let isError = !time ||
			 isNaN(time.Hours) || isNaN(time.Minutes) || isNaN(time.Seconds) ||
			 time.Hours > 99 || time.Hours < 0 || time.Minutes > 59 || time.Minutes < 0 || time.Seconds > 59 || time.Seconds < 0;
		return !isError;
	}

	_getCorrectTime(time: ITimeEditValue | null): ITimeEditValue
	{
		if (!this._isTimeValid(time))
		{
			if (!time)
				return this._getEmptyValue();

			let res = {...time};
			if (res.Hours > 99)
				res.Hours = 99;
			if (res.Hours < 0)
				res.Hours = 0;
			if (res.Minutes > 59)
				res.Minutes = 59;
			if (res.Minutes < 0)
				res.Minutes = 0;
			if (res.Seconds > 59)
				res.Seconds = 59;
			if (res.Seconds < 0)
				res.Seconds = 0;
			return res;
		}
		return time;
	}

	_getTimePartAsString(value: number | null): string
	{
		if (value == null)
		{
			value = 0;
		}
		let res = value.toString();
		if (res.length === 1)
			res = '0' + res;
		else if (res.length > 2)
		{
			res = res.substr(0, 2);
		}
		return res;
	}

	_getCaretPosStart(): number
	{
		return typeof this._input.selectionStart === 'number' ? this._input.selectionStart : 0;
	}

	_getCaretPosEnd(): number
	{
		return typeof this._input.selectionEnd === 'number' ? this._input.selectionEnd : 0;
	}

	_setCaretPos(start: number, end?: number)
	{
		if (end == undefined)
			end = start;
		this._input.selectionStart = start;
		this._input.selectionEnd = end;
	}

	_getNextEditableCharIndex(index: number)
	{
		let res = index;
		let str = this.getValue();
		let ts = NP.getCurrentCulture().TimeSeparator;
		let nextTsIndex = str.indexOf(ts, index);
		if (nextTsIndex === index)
		{
			res += ts.length;
			if (res > str.length)
				res = str.length;
		}
		return res;
	}

	_onInputKeyDown(sender: object, args: EventKeyArgs)
	{
		this.EvKeyDown.fire(this, args);
		if (!this._EnableEdit)
			return;
		let Event = args.Event;
		let keyCode: string | number = Event.key != undefined ? Event.key : Event.keyCode;

		let isDelete = keyCode === 46 || keyCode === 'Delete';
		let isBackspace = keyCode === 8 || keyCode === 'Backspace';

		let char = null;
		switch (keyCode)
		{
			case 48:
			case 49:
			case 50:
			case 51:
			case 52:
			case 53:
			case 54:
			case 55:
			case 56:
			case 57:
				char = keyCode - 48;
				break;
			case 96:
			case 97:
			case 98:
			case 99:
			case 100:
			case 101:
			case 102:
			case 103:
			case 104:
			case 105:
				char = keyCode - 96;
				break;
			case '0':
			case '1':
			case '2':
			case '3':
			case '4':
			case '5':
			case '6':
			case '7':
			case '8':
			case '9':
				char = keyCode;
				break;
		}
		if (char != null)
		{
			let str = this.getValue();
			let carPos = this._getCaretPosStart();
			let editCharIndex = this._getNextEditableCharIndex(carPos);
			let newValue = str.substring(0, editCharIndex) + char + str.substring(editCharIndex + 1);
			if (this._isValid(newValue))
			{
				this.setTimeValue(newValue);
				this._setCaretPos(editCharIndex + 1);
			}
			Event.preventDefault();
		}
		else
		{
			if (isDelete || isBackspace)
			{
				let str = this.getValue();
				let carPosStart = this._getCaretPosStart();
				let carPosEnd = this._getCaretPosEnd();
				if (carPosStart === carPosEnd)
				{
					if (isDelete)
					{
						if (carPosEnd < str.length)
							carPosEnd++;
						else
						{
							Event.preventDefault();
							return;
						}
					}
					else if (isBackspace)
					{
						if (carPosStart > 0)
						{
							carPosStart--;
						}
						else
						{
							Event.preventDefault();
							return;
						}
					}
				}
				let ts = NP.getCurrentCulture().TimeSeparator;
				let newSelectedPart = str.substring(carPosStart, carPosEnd).split('').map(x => x !== ts ? '0' : x).join('');
				let newValue = str.substring(0, carPosStart) + newSelectedPart + str.substring(carPosEnd);
				if (this._isValid(newValue))
				{
					this.setTimeValue(newValue);
					this._setCaretPos(isBackspace ? carPosStart : carPosEnd);
				}
				Event.preventDefault();
			}
		}
	}

	_onInputKeyPress(sender: Control, args: EventKeyArgs)
	{
		args.Event.preventDefault();
		if (this.isLive() && this._Enabled)
		{
			if (args.Event.keyCode == NP.Key.Enter)
				this.EvEnter.fire(this, args);
			return this.EvKeyPress.fire(sender, args);
		}
	}

	onFieldChange()
	{
		let valueStr = this.getValue();
		if (!this._isValid(valueStr))
		{
			super.setValue(this._getTimeAsString(this._TimeValue));
		}
	}

	_onInputCut()
	{
		let str = this._input.value;
		setTimeout(() => super.setValue(str), 0);
	}

	_onInputPaste()
	{
		let posEnd = this._getCaretPosEnd();
		setTimeout(() =>
		{
			let newValue = this._input.value;
			let ts = NP.getCurrentCulture().TimeSeparator;
			newValue = newValue.replace(new RegExp(ts, 'g'), '');
			let maxLength = this._Mode === TimeEditMode.Full ? (6 + ts.length * 2) : (4 + ts.length);
			let i = 2;
			while (i < maxLength && i < newValue.length)
			{
				newValue = newValue.substring(0, i) + ts + newValue.substring(i);
				i += 2 + ts.length;
			}
			if (newValue.length >= maxLength)
			{
				newValue = newValue.substring(0, maxLength);
			}
			if (!this._isValid(newValue))
			{
				super.setValue(this._getTimeAsString(this._TimeValue));
				this._setCaretPos(posEnd);
			}
			else
			{
				this.setTimeValue(newValue);
			}
		}, 0);
	}
}